import * as React from "react";
import cx from "classnames";
import { CloseIcon } from "../../../assets/icons";

export interface ITabItem {
  id?: string;
  title: string;
  component: any;
}

interface TabProps {
  items: ITabItem[];
  initialTabIndex?: number;
  componentContainerClass?: string;
  containerClass?: string;
  tabContainerClass?: string;
  onChangeTab?: (item: ITabItem) => void;
  onClose?: () => void;
  title?: string;
  height?: string;
}

const Tab: React.FC<TabProps> = ({
  items,
  initialTabIndex = 0,
  onChangeTab,
  containerClass,
  componentContainerClass,
  tabContainerClass,
  onClose,
  title = "Help & Support",
  height = "h-[90vh]",
}) => {
  const [activeTab, setActiveTab] = React.useState<number>(0);
  const [isOpen, setIsOpen] = React.useState<boolean>(true);
  React.useEffect(() => {
    if (initialTabIndex <= items.length - 1) {
      setActiveTab(initialTabIndex);
    }
  }, [initialTabIndex, items.length]);

  const handleTabClick = (item: ITabItem, index: number) => {
    setActiveTab(index);
    onChangeTab && onChangeTab(item);
  };

  const handleClose = () => {};

  return (
    <div className="bg-gray-900 bg-opacity-50 fixed top-0 right-0 left-0 z-40 h-[100vh] overflow-auto scrollbar-hide flex items-end md:items-center justify-center">
      <div
        className={cx(
          "overflow-y-auto overflow-x-hidden fixed md:top-[5%] w-full md:w-[500px] lg:w-[538px] p-6 bg-white",
          "rounded-t-[16px] rounded-b-[16px] shadow-md  scrollbar-hide",
          `${height}`, // Added height to ensure scrolling
        )}
      >
        <div className="flex mb-4 justify-center items-center  pt-4">
          <p className="text-[24px] font-semibold">{title}</p>
          <button onClick={onClose} className="absolute top-[42px] right-10">
            <CloseIcon width="30" />
          </button>
        </div>
        <ul
          className={cx(
            "flex border rounded-[5px] p-[3px] bg-gray-100 h-[48px] items-center w-[400px] mx-auto overflow-auto scrollbar-hide mt-8 justify-center   mb-4",
            tabContainerClass,
          )}
        >
          {items.map((item, index) => (
            <li
              key={`tab-${index}`}
              className={cx(
                "cursor-pointer h-full flex items-center justify-center w-[200px] font-medium rounded-[3.31px] px-4",
                {
                  "bg-white": activeTab === index,
                  "bg-transparent": activeTab !== index,
                },
              )}
              onClick={() => handleTabClick(item, index)}
            >
              {item.title}
            </li>
          ))}
        </ul>
        <React.Suspense fallback="Loading...">
          <div className={cx("mt-2", componentContainerClass)}>
            {items[activeTab].component}
          </div>
        </React.Suspense>
      </div>
    </div>
  );
};

export { Tab };
